import { RouteConfig } from "vue-router";

const prenominas: RouteConfig = {
  path: "/prenominas",
  name: "prenominas",
  component: () => import(/* webpackChunkName: "prenominas" */ "@/views/Prenominas.vue"),
};

export default prenominas;
